export enum ChartShape {
  DOT = 'point',
  DIAMOND = 'rectRot',
  MULTIPLY = 'crossRot',
  STAR = 'star',
  TRIANGLE = 'triangle',
  PLUS = 'cross',
  SQUARE = 'rect',
  ROUND = 'circle',
}
